import { baseApi } from '@ibk/shared-config';
export const accountPayableApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        getPaymentDetails: builder.query({
            query: ({ id }) => ({
                url: `/v1/account-payables/employee-payment-details/${id}`,
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
        }),
        postPaymentDetails: builder.mutation({
            query: body => ({
                url: '/v1/account-payables/employee-payment-details',
                method: 'POST',
                body,
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
        }),
        patchPaymentDetails: builder.mutation({
            query: ({ id, body }) => ({
                url: `/v1/account-payables/employee-payment-details/${id}`,
                method: 'PATCH',
                body,
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
        }),
    }),
});
export const { useLazyGetPaymentDetailsQuery, usePostPaymentDetailsMutation, usePatchPaymentDetailsMutation } = accountPayableApi;
